import { render, staticRenderFns } from "./AssetTypeForm.vue?vue&type=template&id=5ca44f76&"
import script from "./AssetTypeForm.vue?vue&type=script&lang=js&"
export * from "./AssetTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./AssetTypeForm.vue?vue&type=style&index=0&id=5ca44f76&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports